import React, { useEffect } from "react";

export const ContentContainer = ({children}) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="contentContainerPublicLayout"
      component="main"
      sx={{
        flexGrow: 1,
        overflow: "hidden",
        overflowX: "hidden",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
};
